var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control-section toast-type-section"},[_c('div',{staticClass:"e-sample-resize-container"},[_c('ejs-toast',{ref:"toastRef",attrs:{"id":"toast_type","position":_vm.position,"timeOut":_vm.timeOut,"target":_vm.target}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }